import { useMemo } from 'react';

export const GET_CARDS_QUERY_PARAMS_KEYS = {
  EMPLOYEE_ID: 'employee_id',
  DEPENDENT_ID: 'dependent_id',
};

export const ROOT_DEPENDENT_ID = 'none';

export const useQueryGenerator = (
  employeeId?: number | string | null,
  dependentId?: number | string | null,
) => {
  return useMemo(() => {
    const queryGenerator = new URLSearchParams();

    if (employeeId) {
      queryGenerator.set(GET_CARDS_QUERY_PARAMS_KEYS.EMPLOYEE_ID, `${employeeId}`);
    }

    if (dependentId && dependentId !== ROOT_DEPENDENT_ID) {
      queryGenerator.set(GET_CARDS_QUERY_PARAMS_KEYS.DEPENDENT_ID, `${dependentId || ROOT_DEPENDENT_ID}`);
    }

    return queryGenerator;
  }, [employeeId, dependentId]);
};
